var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"Dialog"},[_c('div',{staticClass:"backdrop",on:{"click":_vm.close,"wheel":_vm.onWheel}}),_c('div',{staticClass:"panel",style:(_vm.style)},[_c('mdi',{staticClass:"icon-close",attrs:{"close":""},on:{"click":_vm.cancel}}),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }